import { createFileRoute } from '@tanstack/react-router';
import { BroadcastDraftsRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastDraftsRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastDraftsRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/',
)({
  component: BroadcastDraftsRoute,
});
